import axios from 'axios'
import { servers } from '@/helpers'
import store from '@/store'

export const searchScores = async (data) => {
  var queryParams = ''

  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }
  const response = await axios.get(`${servers[store.state.auth.server].platform}/a2e/score${queryParams}`)
  return { items: response.data.scores, total: response.data.scores.length }
}

export default {
  searchScores
}
